var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintForehead = function SvgPaintForehead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 43,
    height: 28,
    viewBox: "0 0 1.11 0.73",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315579601616"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.08.66C.06.4.01.24.3.1.42.05.49.06.61.09c.25.05.38.18.42.44.01.05.01.04.01.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.22.65C.29.6.37.58.45.62v.01M.63.63C.76.54.84.6.89.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.51.5C.47.45.34.38.39.3.44.22.52.32.51.34.55.21.8.25.51.5z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })))));
};

export default SvgPaintForehead;